var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHighlighter48Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3998 9.30005H14.5998C11.6798 9.30005 9.2998 11.68 9.2998 14.6V33.4001C9.2998 36.3201 11.6798 38.7001 14.5998 38.7001H33.3998C36.3198 38.7001 38.6998 36.3201 38.6998 33.4001V14.6C38.6998 11.68 36.3198 9.30005 33.3998 9.30005ZM31.9998 19.52H25.7998V32H22.1998V19.52H15.9998V15.92H31.9998V19.52Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHighlighter48Filled);
export default __webpack_public_path__ + "static/media/icon_highlighter_48_filled.e0cb0cec821265c47b191410a1ed61b8.svg";
export { ForwardRef as ReactComponent };